import { render } from "./TopClick.vue?vue&type=template&id=79ba0a4c&scoped=true"
import script from "./TopClick.vue?vue&type=script&lang=js"
export * from "./TopClick.vue?vue&type=script&lang=js"

import "./TopClick.vue?vue&type=style&index=0&id=79ba0a4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-79ba0a4c"

export default script